import pluralize from "pluralize"
import { Commit } from "vuex/types/index"

/**
 * Recursively set the included relations in the store
 * ? modules MUST implement the correct mutation id "model/SET_MODEL"
 *
 * @export
 * @param {JsonApi.ResourceObject[]} included
 * @param {Commit} commit
 * @param {[type: string]: string} mutationOverrides
 *
 * @example <caption>Handling errors (Promises)</caption>
 * commit('venues/SET_VENUE')
 */
export function setIncludedResources(
  included: JsonApi.ResourceObject[],
  commit: Commit,
  mutationOverrides: { [type: string]: string } = {}
): void {
  if (included && included.length > 0) {
    included.forEach(resource => {
      const { type } = resource
      const singularType = pluralize.singular(type).toUpperCase()
      const commitId = mutationOverrides[type] ? mutationOverrides[type] : `${pluralize(type)}/SET_${singularType}`

      commit(commitId, resource, { root: true })
    })
  }
}
